import React from 'react';
import PropTypes from 'prop-types';
import { toggleModal } from '../app-main/actions/modal';

const MyListingsHoc = (Component) => {
  class hoc extends React.Component {
    constructor (props) {
      super(props);

      this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal (modalId, modalData) {
      this.props.dispatch(toggleModal({ modalId, modalData }));
    }

    render () {
      return <Component {...this.props} toggleModal={this.toggleModal} />;
    }
  }

  hoc.propTypes = {
    dispatch: PropTypes.func
  };

  return hoc;
};

export default MyListingsHoc;
